import React from 'react';

const Privacy: React.FC = () => {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#ffffff',
      fontFamily: '"Inter", "Segoe UI", -apple-system, sans-serif',
      padding: '2rem 0'
    }}>
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '0 2rem'
      }}>
        <h1 style={{
          fontSize: '1.7rem',
          fontWeight: '700',
          color: '#111827',
          textAlign: 'center',
          marginBottom: '2rem',
          fontFamily: '"Playfair Display", "Georgia", serif'
        }}>
          GİZLİLİK POLİTİKASI
        </h1>

        <div style={{
          fontSize: '0.9rem',
          color: '#6b7280',
          textAlign: 'center',
          marginBottom: '3rem',
          fontStyle: 'italic'
        }}>
          Son güncelleme: 03 Ağustos 2025
        </div>

        <div style={{
          fontSize: '1rem',
          lineHeight: '1.8',
          color: '#374151'
        }}>
          <p style={{ marginBottom: '1.5rem' }}>
            Bu Gizlilik Politikası, Kostüm Akademi ("biz", "bizim" veya "şirketimiz") olarak kişisel bilgilerinizi nasıl ve neden topladığımızı, sakladığımızı, kullandığımızı ve/veya paylaştığımızı ("işlediğimizi") açıklar. Bu politika aşağıdaki durumlarda geçerlidir:
          </p>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>https://kostümakademi.com.tr web sitemizi ziyaret ettiğinizde</li>
            <li style={{ marginBottom: '0.5rem' }}>Bizimle satış, pazarlama veya etkinlikler dahil olmak üzere diğer yollarla iletişime geçtiğinizde</li>
          </ul>

          <div style={{
            backgroundColor: '#f8fafc',
            border: '1px solid #e2e8f0',
            borderRadius: '12px',
            padding: '1.5rem',
            marginBottom: '2rem'
          }}>
            <p style={{ marginBottom: '1rem', fontWeight: '600', color: '#111827' }}>
              <strong>Sorularınız mı var?</strong> Bu Gizlilik Politikasını okumak, gizlilik haklarınızı ve seçeneklerinizi anlamanıza yardımcı olacaktır. Kişisel bilgilerinizin nasıl işleneceği konusunda karar verme sorumluluğu bizim üzerimizdedir. Politikalarımızı ve uygulamalarımızı kabul etmiyorsanız, lütfen hizmetlerimizi kullanmayın. Sorularınız varsa elifyldz121@gmail.com adresinden bizimle iletişime geçin.
            </p>
          </div>

          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#111827',
            marginTop: '2rem',
            marginBottom: '1rem',
            fontFamily: '"Playfair Display", "Georgia", serif'
          }}>
            TEMEL NOKTALAR ÖZETİ
          </h2>

          <div style={{
            backgroundColor: '#f8fafc',
            border: '1px solid #e2e8f0',
            borderRadius: '12px',
            padding: '1.5rem',
            marginBottom: '2rem'
          }}>
            <p style={{ marginBottom: '1rem' }}>
              <strong>Hangi kişisel bilgileri işliyoruz?</strong> Hizmetlerimizi ziyaret ettiğinizde, kullandığınızda veya gezindiğinizde, bizimle nasıl etkileşime girdiğinize, yaptığınız seçimlere ve kullandığınız ürün ve özelliklere bağlı olarak kişisel bilgileri işleyebiliriz.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              <strong>Hassas kişisel bilgileri işliyor muyuz?</strong> Hayır, hassas kişisel bilgileri işlemiyoruz.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              <strong>Üçüncü taraflardan bilgi topluyor muyuz?</strong> Hayır, üçüncü taraflardan bilgi toplamıyoruz.
            </p>
            <p style={{ marginBottom: '0' }}>
              <strong>Bilgilerinizi nasıl işliyoruz?</strong> Bilgilerinizi hizmetlerimizi sağlamak, geliştirmek ve yönetmek, sizinle iletişim kurmak, güvenlik ve dolandırıcılık önleme amacıyla işliyoruz.
            </p>
          </div>

          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#111827',
            marginTop: '2rem',
            marginBottom: '1rem',
            fontFamily: '"Playfair Display", "Georgia", serif'
          }}>
            İÇİNDEKİLER
          </h2>

          <ol style={{ marginBottom: '2rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}><a href="#1-hangi-bilgileri-topluyoruz" style={{ color: '#668A69', textDecoration: 'none' }}>HANGİ BİLGİLERİ TOPLUYORUZ?</a></li>
            <li style={{ marginBottom: '0.5rem' }}><a href="#2-bilgilerinizi-nasil-isliyoruz" style={{ color: '#668A69', textDecoration: 'none' }}>BİLGİLERİNİZİ NASIL İŞLİYORUZ?</a></li>
            <li style={{ marginBottom: '0.5rem' }}><a href="#3-kisisel-bilgilerinizi-ne-zaman-ve-kimle-paylasiyoruz" style={{ color: '#668A69', textDecoration: 'none' }}>KİŞİSEL BİLGİLERİNİZİ NE ZAMAN VE KİMLE PAYLAŞIYORUZ?</a></li>
            <li style={{ marginBottom: '0.5rem' }}><a href="#4-cerez-ve-diger-takip-teknolojilerini-kullaniyor-muyuz" style={{ color: '#668A69', textDecoration: 'none' }}>ÇEREZ VE DİĞER TAKİP TEKNOLOJİLERİNİ KULLANIYOR MUYUZ?</a></li>
            <li style={{ marginBottom: '0.5rem' }}><a href="#5-bilgilerinizi-ne-kadar-sure-sakliyoruz" style={{ color: '#668A69', textDecoration: 'none' }}>BİLGİLERİNİZİ NE KADAR SÜRE SAKLIYORUZ?</a></li>
            <li style={{ marginBottom: '0.5rem' }}><a href="#6-bilgilerinizi-nasil-guvenli-tutuyoruz" style={{ color: '#668A69', textDecoration: 'none' }}>BİLGİLERİNİZİ NASIL GÜVENLİ TUTUYORUZ?</a></li>
            <li style={{ marginBottom: '0.5rem' }}><a href="#7-gizlilik-haklariniz-nelerdir" style={{ color: '#668A69', textDecoration: 'none' }}>GİZLİLİK HAKLARINIZ NELERDİR?</a></li>
            <li style={{ marginBottom: '0.5rem' }}><a href="#8-bu-bildirimi-guncellyor-muyuz" style={{ color: '#668A69', textDecoration: 'none' }}>BU BİLDİRİMİ GÜNCELLİYOR MUYUZ?</a></li>
            <li style={{ marginBottom: '0.5rem' }}><a href="#9-bu-bildirim-hakkinda-bizimle-nasil-iletisime-gecebilirsiniz" style={{ color: '#668A69', textDecoration: 'none' }}>BU BİLDİRİM HAKKINDA BİZİMLE NASIL İLETİŞİME GEÇEBİLİRSİNİZ?</a></li>
          </ol>

          <hr style={{ border: '1px solid #e5e7eb', margin: '2rem 0' }} />

          <h2 id="1-hangi-bilgileri-topluyoruz" style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#111827',
            marginTop: '2rem',
            marginBottom: '1rem',
            fontFamily: '"Playfair Display", "Georgia", serif'
          }}>
            1. HANGİ BİLGİLERİ TOPLUYORUZ?
          </h2>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            Bize Sağladığınız Kişisel Bilgiler
          </h3>

          <p style={{ marginBottom: '1rem' }}>
            <strong>Kısaca:</strong> Size tarafımızdan sağlanan kişisel bilgileri topluyoruz.
          </p>

          <p style={{ marginBottom: '1rem' }}>
            Aşağıdaki durumlarda gönüllü olarak sağladığınız kişisel bilgileri topluyoruz:
          </p>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>Hizmetlerimize kayıt olduğunuzda</li>
            <li style={{ marginBottom: '0.5rem' }}>Bizimle veya ürünlerimizle ilgili bilgi almak istediğinizde</li>
            <li style={{ marginBottom: '0.5rem' }}>Hizmetlerimizdeki etkinliklere katıldığınızda</li>
            <li style={{ marginBottom: '0.5rem' }}>Bizimle iletişime geçtiğinizde</li>
          </ul>

          <p style={{ marginBottom: '1rem' }}>
            <strong>Topladığımız kişisel bilgiler şunları içerebilir:</strong>
          </p>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>İsim ve soyisim</li>
            <li style={{ marginBottom: '0.5rem' }}>E-posta adresleri</li>
            <li style={{ marginBottom: '0.5rem' }}>Kullanıcı adları</li>
            <li style={{ marginBottom: '0.5rem' }}>Şifreler</li>
            <li style={{ marginBottom: '0.5rem' }}>Daha iyi hizmet önerileri sunabilmek için kostüm tercihleri ve kiralama geçmişi gibi kullanıcı profil bilgileri</li>
          </ul>

          <p style={{ marginBottom: '1.5rem' }}>
            <strong>Hassas Bilgiler:</strong> Hassas bilgileri işlemiyoruz.
          </p>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            Otomatik Olarak Toplanan Bilgiler
          </h3>

          <p style={{ marginBottom: '1rem' }}>
            <strong>Kısaca:</strong> IP adresiniz ve tarayıcı/cihaz özellikleri gibi bazı bilgiler, hizmetlerimizi ziyaret ettiğinizde otomatik olarak toplanır.
          </p>

          <p style={{ marginBottom: '1rem' }}>
            Hizmetlerimizi ziyaret ettiğinizde, kullandığınızda veya gezindiğinizde belirli bilgileri otomatik olarak topluyoruz. Bu bilgiler şunları içerir:
          </p>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}><strong>Günlük ve Kullanım Verileri:</strong> IP adresiniz, cihaz bilgileri, tarayıcı türü ve ayarları</li>
            <li style={{ marginBottom: '0.5rem' }}><strong>Cihaz Verileri:</strong> Bilgisayar, telefon, tablet gibi cihaz bilgileri</li>
            <li style={{ marginBottom: '0.5rem' }}><strong>Konum Verileri:</strong> Cihazınızın konumu hakkında kesin veya yaklaşık bilgiler</li>
          </ul>

          <hr style={{ border: '1px solid #e5e7eb', margin: '2rem 0' }} />

          <h2 id="2-bilgilerinizi-nasil-isliyoruz" style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#111827',
            marginTop: '2rem',
            marginBottom: '1rem',
            fontFamily: '"Playfair Display", "Georgia", serif'
          }}>
            2. BİLGİLERİNİZİ NASIL İŞLİYORUZ?
          </h2>

          <p style={{ marginBottom: '1rem' }}>
            <strong>Kısaca:</strong> Bilgilerinizi hizmetlerimizi sağlamak, geliştirmek ve yönetmek, sizinle iletişim kurmak, güvenlik ve dolandırıcılık önleme amacıyla işliyoruz.
          </p>

          <p style={{ marginBottom: '1rem' }}>
            Kişisel bilgilerinizi şu amaçlarla işliyoruz:
          </p>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}><strong>Hesap oluşturma ve kimlik doğrulama</strong> için</li>
            <li style={{ marginBottom: '0.5rem' }}><strong>Hizmetlerimizi korumak</strong> için güvenlik ve dolandırıcılık önleme kapsamında</li>
            <li style={{ marginBottom: '0.5rem' }}><strong>Yasal yükümlülüklerimizi yerine getirmek</strong> için</li>
          </ul>

          <hr style={{ border: '1px solid #e5e7eb', margin: '2rem 0' }} />

          <h2 id="3-kisisel-bilgilerinizi-ne-zaman-ve-kimle-paylasiyoruz" style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#111827',
            marginTop: '2rem',
            marginBottom: '1rem',
            fontFamily: '"Playfair Display", "Georgia", serif'
          }}>
            3. KİŞİSEL BİLGİLERİNİZİ NE ZAMAN VE KİMLE PAYLAŞIYORUZ?
          </h2>

          <p style={{ marginBottom: '1rem' }}>
            <strong>Kısaca:</strong> Belirli durumlarda ve belirli üçüncü taraf kategorileriyle bilgi paylaşabiliriz.
          </p>

          <p style={{ marginBottom: '1rem' }}>
            <strong>Satıcılar ve Hizmet Sağlayıcılar:</strong> Bizim için hizmet sunan üçüncü taraf satıcılar, hizmet sağlayıcılar ve acentelerle veri paylaşabiliriz.
          </p>

          <p style={{ marginBottom: '1rem' }}>
            Kişisel bilgileri paylaşabileceğimiz üçüncü taraf kategorileri:
          </p>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>Web sitesi barındırma hizmet sağlayıcıları</li>
            <li style={{ marginBottom: '0.5rem' }}>İletişim ve işbirliği araçları</li>
            <li style={{ marginBottom: '0.5rem' }}>Bulut bilişim hizmetleri</li>
            <li style={{ marginBottom: '0.5rem' }}>Veri analizi hizmetleri</li>
          </ul>

          <hr style={{ border: '1px solid #e5e7eb', margin: '2rem 0' }} />

          <h2 id="4-cerez-ve-diger-takip-teknolojilerini-kullaniyor-muyuz" style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#111827',
            marginTop: '2rem',
            marginBottom: '1rem',
            fontFamily: '"Playfair Display", "Georgia", serif'
          }}>
            4. ÇEREZ VE DİĞER TAKİP TEKNOLOJİLERİNİ KULLANIYOR MUYUZ?
          </h2>

          <p style={{ marginBottom: '1rem' }}>
            <strong>Kısaca:</strong> Bilgilerinizi toplamak ve saklamak için çerezler ve diğer takip teknolojilerini kullanabiliriz.
          </p>

          <p style={{ marginBottom: '1rem' }}>
            Hizmetlerimizle etkileşim kurduğunuzda bilgi toplamak için çerezler ve benzer takip teknolojilerini kullanabiliriz. Bu teknolojiler şu amaçlarla kullanılır:
          </p>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>Hizmetlerimizin ve hesabınızın güvenliğini korumak</li>
            <li style={{ marginBottom: '0.5rem' }}>Çökmeleri önlemek, hataları düzeltmek</li>
            <li style={{ marginBottom: '0.5rem' }}>Tercihlerinizi kaydetmek</li>
            <li style={{ marginBottom: '0.5rem' }}>Temel site işlevlerinde yardımcı olmak</li>
          </ul>

          <hr style={{ border: '1px solid #e5e7eb', margin: '2rem 0' }} />

          <h2 id="5-bilgilerinizi-ne-kadar-sure-sakliyoruz" style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#111827',
            marginTop: '2rem',
            marginBottom: '1rem',
            fontFamily: '"Playfair Display", "Georgia", serif'
          }}>
            5. BİLGİLERİNİZİ NE KADAR SÜRE SAKLIYORUZ?
          </h2>

          <p style={{ marginBottom: '1rem' }}>
            <strong>Kısaca:</strong> Bu Gizlilik Politikasında belirtilen amaçları yerine getirmek için gerekli olduğu sürece bilgilerinizi saklarız.
          </p>

          <p style={{ marginBottom: '1.5rem' }}>
            Kişisel bilgilerinizi yalnızca bu Gizlilik Politikasında belirtilen amaçlar için gerekli olduğu sürece saklarız. Hesabınızın sonlandırılmasından sonra en fazla altı (6) ay daha saklayabiliriz.
          </p>

          <hr style={{ border: '1px solid #e5e7eb', margin: '2rem 0' }} />

          <h2 id="6-bilgilerinizi-nasil-guvenli-tutuyoruz" style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#111827',
            marginTop: '2rem',
            marginBottom: '1rem',
            fontFamily: '"Playfair Display", "Georgia", serif'
          }}>
            6. BİLGİLERİNİZİ NASIL GÜVENLİ TUTUYORUZ?
          </h2>

          <p style={{ marginBottom: '1rem' }}>
            <strong>Kısaca:</strong> Kişisel bilgilerinizi organizasyonel ve teknik güvenlik önlemleri sistemi ile korumayı amaçlıyoruz.
          </p>

          <p style={{ marginBottom: '1.5rem' }}>
            İşlediğimiz kişisel bilgilerin güvenliğini korumak için uygun ve makul teknik ve organizasyonel güvenlik önlemleri uyguladık. Ancak, internet üzerinden hiçbir elektronik iletim veya bilgi depolama teknolojisi %100 güvenli olduğu garanti edilemez.
          </p>

          <hr style={{ border: '1px solid #e5e7eb', margin: '2rem 0' }} />

          <h2 id="7-gizlilik-haklariniz-nelerdir" style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#111827',
            marginTop: '2rem',
            marginBottom: '1rem',
            fontFamily: '"Playfair Display", "Georgia", serif'
          }}>
            7. GİZLİLİK HAKLARINIZ NELERDİR?
          </h2>

          <p style={{ marginBottom: '1rem' }}>
            <strong>Kısaca:</strong> Hesabınızı istediğiniz zaman inceleyebilir, değiştirebilir veya sonlandırabilirsiniz.
          </p>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            KVKK Kapsamındaki Haklarınız:
          </h3>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}><strong>Bilgi talep etme hakkı:</strong> Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
            <li style={{ marginBottom: '0.5rem' }}><strong>Erişim hakkı:</strong> İşlenen kişisel verileriniz hakkında bilgi talep etme</li>
            <li style={{ marginBottom: '0.5rem' }}><strong>Düzeltme hakkı:</strong> Kişisel verilerinizin düzeltilmesini isteme</li>
            <li style={{ marginBottom: '0.5rem' }}><strong>Silme hakkı:</strong> Kişisel verilerinizin silinmesini isteme</li>
            <li style={{ marginBottom: '0.5rem' }}><strong>İtiraz etme hakkı:</strong> Kişisel verilerinizin işlenmesine itiraz etme</li>
            <li style={{ marginBottom: '0.5rem' }}><strong>Veri taşınabilirliği hakkı:</strong> Verilerinizi başka bir veri sorumlusuna aktarma</li>
          </ul>

          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            color: '#374151',
            marginTop: '1.5rem',
            marginBottom: '0.8rem'
          }}>
            Hesap Bilgileri
          </h3>

          <p style={{ marginBottom: '1rem' }}>
            Hesabınızdaki bilgileri incelemek, değiştirmek veya hesabınızı sonlandırmak istiyorsanız:
          </p>

          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>Hesap ayarlarınıza giriş yaparak kullanıcı hesabınızı güncelleyin</li>
            <li style={{ marginBottom: '0.5rem' }}>Sağlanan iletişim bilgilerini kullanarak bizimle iletişime geçin</li>
            <li style={{ marginBottom: '0.5rem' }}>Hesabınızı tamamen silmek için hesap ayarlarındaki "Hesabı Sil" butonunu kullanın</li>
          </ul>

          <p style={{ marginBottom: '1.5rem' }}>
            Hesap silme talebi 30 gün içinde tamamlanır.
          </p>

          <hr style={{ border: '1px solid #e5e7eb', margin: '2rem 0' }} />

          <h2 id="8-bu-bildirimi-guncellyor-muyuz" style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#111827',
            marginTop: '2rem',
            marginBottom: '1rem',
            fontFamily: '"Playfair Display", "Georgia", serif'
          }}>
            8. BU BİLDİRİMİ GÜNCELLİYOR MUYUZ?
          </h2>

          <p style={{ marginBottom: '1rem' }}>
            <strong>Kısaca:</strong> Evet, ilgili yasalara uygunluğu sağlamak için gerektiğinde bu bildirimi güncelleyebiliriz.
          </p>

          <p style={{ marginBottom: '1.5rem' }}>
            Bu Gizlilik Politikasını zaman zaman güncelleyebiliriz. Güncellenen versiyon, bu bildirimin üst kısmındaki "Son güncelleme" tarihi ile gösterilir.
          </p>

          <hr style={{ border: '1px solid #e5e7eb', margin: '2rem 0' }} />

          <h2 id="9-bu-bildirim-hakkinda-bizimle-nasil-iletisime-gecebilirsiniz" style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#111827',
            marginTop: '2rem',
            marginBottom: '1rem',
            fontFamily: '"Playfair Display", "Georgia", serif'
          }}>
            9. BU BİLDİRİM HAKKINDA BİZİMLE NASIL İLETİŞİME GEÇEBİLİRSİNİZ?
          </h2>

          <p style={{ marginBottom: '1.5rem' }}>
            Bu bildirim hakkında sorularınız varsa, bize şu yollarla ulaşabilirsiniz:
          </p>

          <div style={{
            backgroundColor: '#f8fafc',
            border: '1px solid #e2e8f0',
            borderRadius: '12px',
            padding: '1.5rem',
            marginBottom: '1.5rem'
          }}>
            <p style={{ marginBottom: '0.5rem' }}>
              <strong>E-posta: kostumakademi@gmail.com</strong> 
            </p>
            <p style={{ marginBottom: '0.5rem' }}>
           
              Telefon: 0(501) 568 50 55<br />
              Instagram: kostumakademi <br />
              
            </p>
          </div>

          <p style={{ marginBottom: '1.5rem' }}>
            <strong>KVKK Başvuruları için:</strong> Kişisel verilerinizi incelemek, güncellemek veya silmek için veri sorumlusuna başvuru formunu doldurarak gönderebilir veya yukarıdaki iletişim bilgilerini kullanabilirsiniz.
          </p>

          <hr style={{ border: '1px solid #e5e7eb', margin: '2rem 0' }} />

          <div style={{
            backgroundColor: '#f8fafc',
            border: '1px solid #e2e8f0',
            borderRadius: '12px',
            padding: '1.5rem',
            marginTop: '2rem',
            textAlign: 'center'
          }}>
            <p style={{
              fontSize: '0.8rem',
              color: '#6b7280',
              fontStyle: 'italic',
              margin: 0
            }}>
              Bu gizlilik politikası KVKK (Kişisel Verilerin Korunması Kanunu) ve ilgili mevzuata uygun olarak hazırlanmıştır.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy; 